import React from "react";
import dataSuccess from "../../data/dataSuccess";
import dataPhotovoltaique from "../../data/dataPhotovoltaique";
import NavSuccess from "./NavSuccess";
import SuccessTemplateSidebar from "./SuccessTemplateSidebar";
import FileUploaderAuto from "./FileUploaderAuto";
class SuccessPhotovoltaique extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const offre = this.props.result.data.Offre;
    const panneaux = dataPhotovoltaique[offre].panneaux;
    const packname = dataPhotovoltaique[offre].packName;
    const pack = dataPhotovoltaique[offre].pack;
    const price = this.props.result.data["Coût travaux unitaire (€)"];
    const monthly = this.props.result.data["Coût travaux unitaire mensuel (€)"];
    const prime = this.props.result.data["Montant total prime (€)"];
    const reste = this.props.result.data["Reste à charge unitaire (€)"];
    const montantPromo = this.props.resultCodePromo.data.montant_promo;
    const codePromoReste = this.props.resultCodePromo.data.reste_a_charge;
    const bgMobile = `url(${dataSuccess[this.props.success].imgMobile})`;
    const paragraphSolaire =
      "*Cette prime est versée automatiquement par EDF Obligation d'Achat en même temps que vos revenus générés par la vente de votre surplus sur la première année.";
    return (
      <div className="flex-container">
        <SuccessTemplateSidebar
          success={this.props.success}
          lastStep={this.props.lastStep}
          codePromo={this.props.codePromo}
          handleCodePromo={this.props.handleCodePromo}
          validCodePromo={this.props.validCodePromo}
          resultCodePromo={this.props.resultCodePromo}
        >
          <div className="success-item">
            <h3>Type de logement</h3>
            <h2>{this.props.Q2}</h2>
          </div>

          {this.props.facture && (
            <div className="success-item">
              <h3>Facture d’électricité / mois</h3>
              <h2>{this.props.facture} €</h2>
            </div>
          )}
          <div className="success-item">
            <h3>Type de contrat</h3>
            <h2>{this.props.Q16}</h2>
          </div>
        </SuccessTemplateSidebar>

        <div className="success-right-container">
          <p className="text-s fw-300 mt-10">
            Recommandation : Pack {packname} {pack} kWc{" "}
          </p>
          <div className="success-item-right">
            <h5>Prix pour {panneaux} panneaux solaires</h5>
            <div>
              <h5 className="h5-price">{price} € </h5>
              <h6
                className="text-main align-right"
                style={{ fontSize: "14px" }}
              >
                ou {monthly}€/mois
              </h6>
            </div>
          </div>
          <div className="success-item-right">
            <div>
              <h2
                className="text-main"
                style={{ fontSize: "24px", lineHeight: "26px" }}
              >
                Prime à l’autoconsommation*
              </h2>
            </div>

            <div>
              <h5 className="h5-prime">- {prime} € </h5>
            </div>
          </div>

          {montantPromo && (
            <div className="success-item-right">
              <div>
                <h2
                  className="text-main"
                  style={{ fontSize: "24px", lineHeight: "26px" }}
                >
                  Code Promo
                </h2>
              </div>

              <div>
                <h5 className="h5-prime">- {montantPromo} € </h5>
              </div>
            </div>
          )}

          <div className="success-item-right last">
            <h5>Reste à payer</h5>
            <div>
              {!codePromoReste && <h5 className="h5-price"> {reste} € </h5>}
              {codePromoReste && (
                <h5 className="h5-price"> {codePromoReste} € </h5>
              )}
            </div>
          </div>
          {this.props.showFile && (
            <FileUploaderAuto
              patchName="fileImposition"
              description="Déposez votre avis imposition pour valider le montant de votre prime"
              handleFile={this.props.handleFile}
              result={this.props.result}
              firstname={this.props.contact.firstname}
              lastname={this.props.contact.lastname}
            ></FileUploaderAuto>
          )}

          <NavSuccess
            callBtn={this.props.callBtn}
            lastStep={this.props.lastStep}
            date={this.props.date}
            creneau={this.props.creneau}
            handleDate={this.props.handleDate}
            handleCreneau={this.props.handleCreneau}
          ></NavSuccess>

          <p className="text-s text-main mb-5">
            Hellio s’occupe de toutes vos démarches administratives.
          </p>
          <p className="paragraph">{paragraphSolaire}</p>
        </div>
        <div
          style={{
            backgroundImage: bgMobile,
          }}
          className="success-header-img only-show-mobile"
        >
          <h1>{dataSuccess[this.props.success].h1}</h1>
        </div>
      </div>
    );
  }
}

export default SuccessPhotovoltaique;
